module.exports = __webpack_public_path__ + "static/media/integration-email.3ec14a05.svg";